import { Application } from "@hotwired/stimulus"
import Sortable from '@stimulus-components/sortable'
import Clipboard from '@stimulus-components/clipboard'
import ColorPicker from '@stimulus-components/color-picker'
import FilterrificController from "filterrific_stimulus_controller"
import RailsNestedForm from '@stimulus-components/rails-nested-form'

const application = Application.start()
application.register('sortable', Sortable)
application.register('clipboard', Clipboard)
application.register('color-picker', ColorPicker)
application.register('filterrific', FilterrificController)
application.register('nested-form', RailsNestedForm)

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }
